export type TariffKey = '512GB' | '1TB';

export interface TariffConfig {
    tariffId: string;
    startImg: string;
    endImg: string;
    animation: string;
    erid: string;
}

export interface TouchTariffConfig {
    startImg: string;
    endImg: string;
    animation: string;
}

export interface SummerCampaign2026ModalProps {
    onClose?: () => void;
    hide?: () => void;
    complete?: () => void;
}

export interface StoredTariffData {
    tariff: TariffKey;
    timestamp: number;
}

export enum ImageStates {
    start = 'start',
    end = 'end',
    inProgress = 'inProgress',
}
